/*
 * Module for the _Appointments partial view
*/
rs.module("ui/content/events/counselingappointments/appointments",

    [],

    function () {

        // Initialize the module
        function initialize(listApi, backendUrls) {

            // load the corresponding detail when a list item is clicked
            listApi.onItemClick(function (e, context) {

                $.get(
                    backendUrls.getCounselingAppointmentDetail,
                    {
                        appointmentKey: context.AppointmentKey,
                        accountPartyKey: context.AccountPartyKey
                    })
                    .done(function (html) {
                        listApi.detail.loadDetail(html);
                    })
                    .fail(function () {
                        // if the detail retrieve failed, show empty detail
                        listApi.detail.clearDetail();
                    });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);